module.exports = __webpack_public_path__ + "media/soulc.b61d3bf0.webm";